@if (Company) {
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <h2>
          QuickSourceBids -
          {{ currentRouteToInformationMap[currentRoute].title }}
        </h2>
      </div>
    </div>
    @if ((ProposalRequestId && ProposalRequest) || !ProposalRequestId) {
      <div class="row">
        <div class="col-9 g-0">
          <router-outlet></router-outlet>
        </div>
        <div class="col-3">
          <app-quicksource-tracker
            [ProposalRequestId]="ProposalRequestId"
            [QuickSourceProgressMap]="QuickSourceProgressMap"
            (stepChangeEvent)="goToStep($event)"
          ></app-quicksource-tracker>
        </div>
      </div>
    }
    <!-- Wizard footer — the routed step's form.container-fluid receives a
         global `padding: 28px 32px ...` rule (core.less), so the form's
         content (the cards) is inset 32px on each side from the col-9
         boundary. The action-row lives OUTSIDE that form, so we apply
         matching 32px horizontal padding here to line up its right edge
         with the cards above. -->
    <div class="row mt-2 mb-3 wizard-footer">
      <div class="col-9 g-0">
        <div class="action-row justify-end">
          <button type="button" class="btn btn-ghost" (click)="cancel()">
            Cancel
          </button>
          @if (currentRoute !== 'site-selection') {
            <button type="button" class="btn btn-outline" (click)="previous()">
              Previous
            </button>
          }
          @if (currentRoute !== 'review') {
            <button type="button" class="btn btn-primary" (click)="continue()">
              Next
            </button>
          }
          @if (currentRoute === 'review' && !disableInput) {
            <button type="button" class="btn btn-accent" (click)="finish()">
              Release and email vendors
            </button>
          }
        </div>
      </div>
    </div>
  </div>
}
